var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon37(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 176.94 176.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #4e3721;\n      }\n\n      .cls-2 {\n        filter: url(#drop-shadow-33);\n      }\n\n      .cls-3 {\n        fill: none;\n        stroke: #fff;\n        stroke-linecap: round;\n        stroke-width: 13.06px;\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-33",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 35.32
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 25.23
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 88.47,
    cy: 88.47,
    r: 88.47
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 52.05,
    y: 82.49,
    width: 72.84,
    height: 57.65,
    rx: 8.91,
    ry: 8.91
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M88.47,36.81h0c12.61,0,22.84,10.23,22.84,22.84v22.84h-45.68v-22.84c0-12.61,10.23-22.84,22.84-22.84Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon37);
export default __webpack_public_path__ + "static/media/icon-37.5854f77e50ec46bacdf7cd3767b4cc10.svg";
export { ForwardRef as ReactComponent };